import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MenuPanel from "./MenuPanel";
import TermsPanel from './TermsPanel';
import FooterPanel from './FooterPanel';

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class TermsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
      const { classes } = this.props;

      return (
          <div className={classes.branding}>
              <MenuPanel page={'about'}/>
              <TermsPanel/>
              <FooterPanel/>
          </div>
      );
  }
}

export default withStyles(useStyles)(TermsPage)
